<template>
  <div class="notifications_div">
    <div
      style="
        text-align: center;

        border-bottom: 2px solid #2b2d2f;
      "
    >
      <v-btn icon style="margin-top: -5px">
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <b style="font-size: 19px">{{ headline }}</b>
      <v-btn icon style="margin-top: -5px">
        <v-icon @click="isNotify = !isNotify"
          >mdi-arrow-down-bold-circle-outline</v-icon
        >
      </v-btn>
    </div>

    <div class="notify_expand" v-if="isNotify">
      <notification></notification>
      <notification></notification>
      <notification></notification>
      <notification></notification>
      <notification></notification>
    </div>
  </div>
</template>

<script>
import notification from "./notification";

export default {
  name: "notificationbar",
  data: function () {
    return {
      isNotify: true,
    };
  },
  props: ["headline"],
  components: {
    notification,
  },
};
</script>

<style lang="scss" scoped>
.notifications_div {
  position: absolute;
  //right: 0;
  //top: 0%;
  //transform: translate(0%, 15%);

  width: 280px;
  height: 550px;

  font-family: "Raleway";
  background-color: transparent;
}

.notify_expand {
  width: 280px;
  height: 500px;

  text-align: right;

  //margin-left: 25px;
  overflow-y: scroll;
}

.notify_expand::-webkit-scrollbar {
  display: none;
}

.notify_expand {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>